/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'react-dom',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit',
	'../../../../widgets/livewidget/nls/StringResources'
], function(
	React,
	ReactDOM,
	PropTypes,
	UI_Toolkit,
	stringResources
) {
	const { Component } = React;
	const { FlexLayout, FlexItem, Label, SVGIcon } = UI_Toolkit;

	class CustomVisPreviewMessage extends Component {
		constructor(props){
			super(props);

			this.getInformation16 = props.iconsFeature.getIcon('getInformation');
		}

		render () {
			return (
				<FlexLayout
					direction='row'
					fullHeight
					justifyContent='center'
				>
					<FlexItem>
						<FlexLayout
							wrap='wrap'
							direction='row'
						>
							<FlexItem>
								<SVGIcon
									iconId={this.getInformation16.id}
									verticalAlign='middle'
									className='customVisInfoIcon' />
							</FlexItem>
							<FlexItem
								wrap='wrap'
								white-space='normal'
							>
								<Label
									label={stringResources.get('extVisPreviewMessage')}
								/>
							</FlexItem>
						</FlexLayout>
					</FlexItem>
				</FlexLayout>
			);
		}
	}

	CustomVisPreviewMessage.propTypes = {
		iconsFeature: PropTypes.object.isRequired
	};

	return CustomVisPreviewMessage;
});
